export function initInitialedForm(buyButton, isCertPage = false) {
  if (!buyButton) return;

  const checkbox = document.getElementById("checkInitialed");
  const initials = document.getElementById("initials");
  const certificateSelect = document.querySelector(".js-certificate-number");
  const tierDropdown = document.getElementById("tierDropdown");
  const priceEl = document.querySelector(".sp__price");
  const originalHref = buyButton.href;

  if (!checkbox || !initials) return;

  const getGuid = () => new URL(buyButton.href).searchParams.get("GUID");
  const isValid = () => {
    const checked = checkbox.checked;
    const filled = initials.value.trim().length > 0;
    const hasGuid = !!getGuid();
    return isCertPage ? checked && filled && hasGuid : checked && filled;
  };

  const validate = () => buyButton.classList.toggle("disabled", !isValid());

  // User interactions
  checkbox.addEventListener("change", validate);
  initials.addEventListener("input", validate);
  if (certificateSelect) certificateSelect.addEventListener("change", validate);

  buyButton.addEventListener("click", (e) => {
    if (!buyButton.classList.contains("disabled")) return;
    e.preventDefault();
    const checked = checkbox.checked;
    const filled = initials.value.trim().length > 0;
    const hasGuid = !!getGuid();
    let msg =
      "Please check and initial the acknowledgement. After editing the certificate, you must save and preview the certificate before you can purchase it.";
    if (isCertPage && checked && filled && !hasGuid)
      msg = "Make sure that a certificate is saved and previewed.";
    alert(msg);
  });

  // Tiered Price
  if (tierDropdown && priceEl) {
    tierDropdown.addEventListener("change", function () {
      const opt = this.options[this.selectedIndex];
      const tier = opt.dataset.tier;
      const price = opt.value;
      priceEl.textContent = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      }).format(price);

      buyButton.href =
        tier === "tier_a"
          ? `${originalHref}&PT=CC-A`
          : tier === "tier_b"
            ? `${originalHref}&PT=CC-B`
            : tier === "tier_c"
              ? `${originalHref}&PT=CC-C`
              : originalHref;

      validate();
    });
  }

  // Listen for GUID updates from certificate module
  document.addEventListener("certificate-guid-updated", validate);

  // Initial check
  validate();
}
